import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  IConsultationSlot,
  IConsultationBooking,
  ICreateBookingRequest,
} from '../../../assets/types/dtoTypes';

@Injectable({ providedIn: 'root' })
export class ConsultationService {
  private http = inject(HttpClient);

  private url = `${environment.apiUrl}/consultation`;

  getSlots(from: Date, to: Date): Observable<IConsultationSlot[]> {
    const params = new HttpParams()
      .set('from', from.toISOString())
      .set('to', to.toISOString());
    return this.http.get<IConsultationSlot[]>(`${this.url}/slots`, { params });
  }

  createBooking(request: ICreateBookingRequest): Observable<IConsultationBooking> {
    return this.http.post<IConsultationBooking>(`${this.url}/bookings`, request);
  }
}
